/** チケットに対応するスレッドの選び方（BE の `_resolve_ticket_thread` と同じ規則）。
 *
 * 統合すると吸収側スレッドは `status='closed'` + `related_id=primary` として残るため、
 * 「id が大きい方」だけで選ぶと中身を移し終えた空の孤立スレッドを掴んでしまう
 * （NX-S-2026-07-28-000001 で会話 9 件が画面から消えた）。
 * **生存スレッド（closed 以外）を優先**し、全部 closed のときだけ id 降順にフォールバックする。 */

import type { Thread } from "../types.ts";

export function isTicketThread(t: Thread): boolean {
  return t.thread_type === "support" || t.thread_type === "urgent";
}

function betterThread(a: Thread, b: Thread): Thread {
  const aClosed = a.status === "closed";
  const bClosed = b.status === "closed";
  if (aClosed !== bClosed) return aClosed ? b : a;
  return a.id >= b.id ? a : b;
}

/** ticketId に紐づくスレッドを 1 本選ぶ。 */
export function pickTicketThread(threads: Thread[], ticketId: number): Thread | undefined {
  let best: Thread | undefined;
  for (const t of threads) {
    if (!isTicketThread(t) || t.related_id !== ticketId) continue;
    best = best ? betterThread(best, t) : t;
  }
  return best;
}

/** チケット id → スレッド id の対応表をまとめて作る。 */
export function buildThreadByTicket(threads: Thread[]): Record<number, number> {
  const best: Record<number, Thread> = {};
  for (const t of threads) {
    if (!isTicketThread(t) || t.related_id == null) continue;
    const cur = best[t.related_id];
    best[t.related_id] = cur ? betterThread(cur, t) : t;
  }
  const out: Record<number, number> = {};
  for (const [k, v] of Object.entries(best)) out[Number(k)] = v.id;
  return out;
}
